module.exports = __webpack_public_path__ + "img/sri_lanka.ded1f02.webp";